(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .controller('TituloElectronicoAngDetailController', TituloElectronicoAngDetailController);

    TituloElectronicoAngDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TituloElectronico'];

    function TituloElectronicoAngDetailController($scope, $rootScope, $stateParams, previousState, entity, TituloElectronico) {
        var vm = this;

        vm.tituloElectronico = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('verificadocumentoApp:tituloElectronicoUpdate', function(event, result) {
            vm.tituloElectronico = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
